export default "__VITE_ASSET__c8680701__"